import { DialogPlugin, MessagePlugin, message } from 'tdesign-react';
const duration = 2000;

export const errorToast = (content: string): void => {
  MessagePlugin.closeAll();
  message.error({
    content,
    placement: 'top',
    zIndex: 7000,
    duration,
  }, duration);
};

export const infoToast = (content: string): void => {
  MessagePlugin.closeAll();
  message.info({
    content,
    placement: 'top',
    zIndex: 7000,
    duration,
  }, duration);
};

export const successToast = (content: string): void => {
  MessagePlugin.closeAll();
  message.success({
    content,
    placement: 'top',
    zIndex: 7000,
    duration,
  }, duration);
};

export const warningToast = (content: string): void => {
  MessagePlugin.closeAll();
  message.warning({
    content,
    placement: 'top',
    zIndex: 7000,
    duration,
  }, duration);
};
